export type BodySalesConversion =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sucursal: string;
    };

export interface ResponseSalesConversion {
  fechas:    DateSalesConversion[];
  resumen:   SummarySalesConversion;
  anio_base: string;
}

export interface DateSalesConversion {
  periodo_fecha:         string;
  ventas:                number;
  total_facturas:       number;
  visitantes:            number;
  porcentaje_conversion: string;
  ticket_promedio:       number;
}

export interface SummarySalesConversion {
  total_ventas:                number;
  total_facturas:             number;
  total_visitantes:            number;
  ticket_promedio_total:       number;
  porcentaje_conversion_total: string;
}
